import { createSlice } from '@reduxjs/toolkit'
// import {markupTableData} from '../../utils/DragDropMarkupData'


const initialState = {
    markupTableData: {},
    markupTableDataCC: {},
    isTbGrouping: true,
    clearGroupingFilter: false,
    disableGroupingFilter: true,
    showColumns: {
      "A/c Code": {
          name: 'accountCode',
          type: "QBO",
          isSelected: true
      },
      "A/c Name": {
          name: 'accountName',
          type: "QBO",
          isSelected: true
      },
      "Account Type": {
          name: 'accountType',
          type: "QBO",
          isSelected: true
      },
      "Detail Type": {
          name: 'detailType',
          type: "QBO",
          isSelected: true
      },
      "QB Balance": {
          name: 'qbBalance',
          type: "QBO",
          isSelected: true
      },
      "Statement": {
          name: 'statement',
          type: "SCHG",
          isSelected: true
      },
      "Head":  {
          name: 'head',
          type: "SCHG",
          isSelected: true
      },
      "Caption": {
          name: 'caption',
          type: "SCHG",
          isSelected: true
      },
      // "Alternate Captions": {
      //     name: 'altenateCaption',
      //     type: "SCHG",
      //     isSelected: false
      // }
    },
    showColumnsCFS:{
      // "S.No.": {
      //     name: 'serialNumber',
      //     type: "QBO",
      //     isSelected: true
      // },
      "Date": {
          name: 'date',
          type: "QBO",
          isSelected: true
      },
      "Transaction type": {
          name: 'transactionType',
          type: "QBO",
          isSelected: false
      },
      "Number": {
          name: 'number',
          type: "QBO",
          isSelected: false
      },
      "A/c Code": {
          name: 'accountCode',
          type: "QBO",
          isSelected: true
      },
      "A/c Name": {
          name: 'accountName',
          type: "QBO",
          isSelected: true
      },
      // "Debit": {
      //     name: 'debit',
      //     type: "QBO",
      //     isSelected: true
      // },
      // "Credit": {
      //     name: 'credit',
      //     type: "QBO",
      //     isSelected: true
      // },
      // "Head": {
      //     name: 'head',
      //     type: "TB",
      //     isSelected: false
      // },
      // "Caption": {
      //     name: 'Caption',
      //     type: "TB",
      //     isSelected: false
      // },
      // "Indirect Method": {
      //     name: 'indirectRow',
      //     type: "CFS",
      //     isSelected: true
      // },
      // "Direct Method": {
      //     name: 'indirectRow',
      //     type: "CFS",
      //     isSelected: true
      // },
      "Schedules Caption": {
        name: 'schedulesColumns',
        type: "SCHG",
        isSelected: false
      },
      "Cashflow Method": {
        name: 'cashflowMethods',
        type: "CFS",
        isSelected: true
      },
      "Period 2": {
        name: 'periodTwo',
        type: "CFS",
        isSelected: false
      },
      "Amount $": {
        name: 'amount',
        type: "QBO",
        isSelected: true
      }
    },
    showColumnsCfsLibrary: {
      "Indirect Method": {
        name: 'indirectRow',
        type: "CFS",
        isSelected: true
      },
      "Direct Method": {
        name: 'indirectRow',
        type: "CFS",
        isSelected: true
      }
    }

  }

  const markupTableDataSlice = createSlice({
    name: 'markupTableData',
    initialState,
    reducers: {
      setMarkupTableData: (state, action) => {
        state.markupTableData = action.payload;
        state.markupTableDataCC = action.payload
      },
      setClearGroupingFilter: (state, action) => {
        state.clearGroupingFilter = action.payload;
      },
      setDisableClearFilter: (state, action) => {
        state.disableGroupingFilter = action.payload;
      },
      setIsTbGrouping: (state, action) => {
        state.isTbGrouping = action.payload;
      },
      // updateValue: (state, action) => {
      //   const { heading, category, subCategory, newValue, secondPeriod } = action.payload;
      //   let missedPeriodYear = "";
      //   Object.entries(state.markupTableData[heading][category])?.map(([key1, value1], index) =>{
      //     if(key1 === subCategory) {
      //       let matchFound = false;
      //       if(secondPeriod){
      //         state.markupTableData[heading][category][key1].value?.map((item, idx) => {
      //           if(item?.title === newValue?.title && item?.accountType === newValue?.accountType) {
      //             item.balance = {...item.balance, ...newValue.balance}
      //             matchFound = true;
      //           }
      //         });

      //         if(!matchFound){
      //           let unMatchedItem = JSON.parse(JSON.stringify(newValue));
      //           unMatchedItem.balance = {
      //             ["periodTwo"]: { debit: null, credit: null },
      //             ...unMatchedItem.balance
      //           };
      //           state.markupTableData[heading][category][subCategory].value.push(unMatchedItem);
      //         }
      //       } else {
      //         state.markupTableData[heading][category][subCategory].value.push(newValue);
      //       }
      //     } else {
      //       if(value1["ALTERNATE CAPTIONS"]) {
      //         Object.entries(value1["ALTERNATE CAPTIONS"])?.map(([key2, value2], ind) => {
      //           if(key2 === subCategory){
      //             let matchFound = false;
      //             if(secondPeriod){
      //               state.markupTableData[heading][category][key1]['ALTERNATE CAPTIONS'][key2].value?.map((item, idx) => {
      //                 if(item?.title === newValue?.title && item?.accountType === newValue?.accountType) {
      //                   item.balance = {...item.balance, ...newValue.balance}
      //                   matchFound = true
      //                 }
      //               });

      //               if(!matchFound){
      //                 let unMatchedItem = JSON.parse(JSON.stringify(newValue));
      //                 unMatchedItem.balance = {
      //                   ["periodTwo"]: { debit: null, credit: null },
      //                   ...unMatchedItem.balance
      //                 };
      //                 state.markupTableData[heading][category][key1]['ALTERNATE CAPTIONS'][key2].value.push(unMatchedItem);
      //               }
      //             } else {
      //               state.markupTableData[heading][category][key1]['ALTERNATE CAPTIONS'][key2].value.push(newValue);
      //               // if(!secondPeriod){
      //               //   missedPeriodYear = Object.keys(value2.value[0].balance)[0]
      //               // }
      //             }
      //           }
      //         })
      //       }
      //     }
      //   })
      // },

      // updateValue: (state, action) => {
      //   const { heading, category, subCategory, newValue, secondPeriod } = action.payload;
      
      //   // Helper function to ensure both periods are present in the balance object
      //   const ensureBothPeriods = (balance, secondPeriod) => {
      //     const periods = ["periodOne", "periodTwo"];
      //     periods.forEach((period) => {
      //       if (!balance[period]) {
      //         balance[period] = { credit: null, debit: null };
      //       }
      //     });
      //     return balance;
      //   };
      
      //   // Helper function to update or add a value
      //   const updateOrAddValue = (valueArray, newValue, secondPeriod) => {
      //     const existingItem = valueArray.find(
      //       (item) => item.title === newValue.title && item.accountType === newValue.accountType
      //     );
      
      //     if (existingItem) {
      //       // Ensure both periods are present before merging balances
      //       existingItem.balance = ensureBothPeriods(
      //         { ...existingItem.balance, ...newValue.balance },
      //         secondPeriod
      //       );
      //     } else {
      //       // Add both periods to the new value before pushing
      //       const unmatchedItem = {
      //         ...newValue,
      //         balance: ensureBothPeriods(newValue.balance, secondPeriod),
      //       };
      //       valueArray.push(unmatchedItem);
      //     }
      //   };
      // console.log("markup", current(state.markupTableData), "heading - ", heading, "category - ", category, "newValue", newValue, "second", secondPeriod)
      //   // Iterate over the category's entries
      //   Object.entries(state.markupTableData[heading][category]).forEach(([key1, value1]) => {
      //     console.log("1")
      //     if (key1 === subCategory) {
      //       console.log("2")
      //       updateOrAddValue(state.markupTableData[heading][category][key1].value, newValue, secondPeriod);
      //     } else if (value1["ALTERNATE CAPTIONS"]) {
      //       console.log("3")
      //       Object.entries(value1["ALTERNATE CAPTIONS"]).forEach(([key2, value2]) => {
      //         if (key2 === subCategory) {
      //           console.log("4")
      //           updateOrAddValue(value2.value, newValue, secondPeriod);
      //         }
      //       });
      //     }
      //   });
      // },      
      updateValue: (state, action) => {
        const { heading, category, subCategory, newValue, secondPeriod } = action.payload;
        // console.log("grp-----", {heading, category, subCategory, newValue, secondPeriod})
        // let missedPeriodYear = "";
        Object.entries(state.markupTableData[heading][category])?.forEach(([key1, value1], index) =>{
          if(key1 === subCategory) {
            let matchFound = false;
            if(secondPeriod){
              state.markupTableData[heading][category][key1].value?.forEach((item, idx) => {
                if(item?.title === newValue?.title && item?.accountType === newValue?.accountType) {
                  item.balance = {...item.balance, ...newValue.balance}
                  matchFound = true;
                }
              });

              if(!matchFound){
                let unMatchedItem = JSON.parse(JSON.stringify(newValue));
                unMatchedItem.balance = {
                  [secondPeriod]: { debit: null, credit: null },
                  ...unMatchedItem.balance
                };
                state.markupTableData[heading][category][subCategory].value.push(unMatchedItem);
              }
            } else {
              state.markupTableData[heading][category][subCategory].value.push(newValue);
              
              // if(!secondPeriod){
              //   console.log("value",current(value1.value[0]))
              //   missedPeriodYear = Object.keys(value1?.value[0]?.balance)[0]
              // }
            }
          } else {
            if(value1["ALTERNATE CAPTIONS"]) {
              Object.entries(value1["ALTERNATE CAPTIONS"])?.forEach(([key2, value2], ind) => {
                if(key2 === subCategory){
                  let matchFound = false;
                  if(secondPeriod){
                    state.markupTableData[heading][category][key1]['ALTERNATE CAPTIONS'][key2].value?.forEach((item, idx) => {
                      if(item?.title === newValue?.title && item?.accountType === newValue?.accountType) {
                        item.balance = {...item.balance, ...newValue.balance}
                        matchFound = true
                      }
                    });

                    if(!matchFound){
                      let unMatchedItem = JSON.parse(JSON.stringify(newValue));
                      unMatchedItem.balance = {
                        [secondPeriod]: { debit: null, credit: null },
                        ...unMatchedItem.balance
                      };
                      state.markupTableData[heading][category][key1]['ALTERNATE CAPTIONS'][key2].value.push(unMatchedItem);
                    }
                  } else {
                    state.markupTableData[heading][category][key1]['ALTERNATE CAPTIONS'][key2].value.push(newValue);
                    // if(!secondPeriod){
                    //   missedPeriodYear = Object.keys(value2.value[0].balance)[0]
                    // }
                  }
                }
              })
            }
          }
        })
      },
      resetMarkupData: (state, action) => {
        state.markupTableData = state.markupTableDataCC
      },
      addNewOptions: (state, action) => {
        const { statement, head, row, alternateCaption } = action.payload;

        if (!statement) return;

        // normalize keys (important for consistency)
        const statementKey = statement.toUpperCase();
        const headKey = head?.toUpperCase();
        const rowKey = row;

        // ensure statement exists
        const statementObj = state.markupTableData[statementKey] ??= {};

        // if only statement is provided
        if (statementKey && !headKey && !rowKey && !alternateCaption) {
          return;
        }

        // ensure head exists
        const headObj = headKey ? (statementObj[headKey] ??= {}) : null;

        // if statement + head only
        if (statementKey && headKey && !rowKey && !alternateCaption) {
          return;
        }

        // ensure row exists
        const rowObj = rowKey
          ? (headObj[rowKey] ??= { value: [], "ALTERNATE CAPTIONS": {} })
          : null;

        // if statement + head + row only
        if (statementKey && headKey && rowKey && !alternateCaption) {
          return;
        }

        // ensure alternate captions container exists
        const altCaptions = rowObj
          ? (rowObj["ALTERNATE CAPTIONS"] ??= {})
          : null;

        // add alternate caption if missing
        if (alternateCaption && !altCaptions[alternateCaption]) {
          altCaptions[alternateCaption] = { value: [] };
        }
      },
      setShowColumns: (state, action) => {
        const { column } = action.payload;
        if (column && state.showColumns[column]) {
          state.showColumns[column].isSelected = !state.showColumns[column].isSelected;
        }
      },
      setShowColumnsForPeriods: (state, action) => {
        const periodLabels = action.payload; // e.g., ["YE 12/31/2021", "YE 12/31/2022"]
        const newColumns = {};
        // const keys = Object.keys(state.showColumns);
        const keys = state.showColumns;
        
        // Locate "QB Balance" index
        // const qbIndex = keys.indexOf("QB Balance");
      
        Object.entries(keys).forEach(([key, value], idx) => {
          if (key === "QB Balance") {
            // Inject new period columns in place of "QB Balance"
            periodLabels.forEach((label, i) => {
              newColumns[label] = {
                name: i === 0 ? "amountP1" : "amountP2",
                type: "QBO",
                isSelected: true,
              };
            });
          } else if(value.name.startsWith("amount")) {
            if(value.name === "amountP1") {
              periodLabels.forEach((label, i) => {
                newColumns[label] = {
                  name: i === 0 ? "amountP1" : "amountP2",
                  type: "QBO",
                  isSelected: true,
                };
              });
            }
          } 
          else {
            // Preserve all other columns
            newColumns[key] = state.showColumns[key];
          }
        });
        state.showColumns = newColumns;
      },
      setShowColumnsCFS: (state, action) => {
        const { column } = action.payload;
        if (column && state.showColumnsCFS[column]) {
          state.showColumnsCFS[column].isSelected = !state.showColumnsCFS[column].isSelected;
        }
      },
      setShowColumnsCfsLibrary: (state, action) => {
        const { column } = action.payload;
        if (column && state.showColumnsCfsLibrary[column]) {
          state.showColumnsCfsLibrary[column].isSelected = !state.showColumnsCfsLibrary[column].isSelected;
        }
      }
    }
  });
  
  export const {setMarkupTableData, setClearGroupingFilter, setDisableClearFilter, updateValue, resetMarkupData, addNewOptions, setShowColumns, setShowColumnsForPeriods, setShowColumnsCFS, setShowColumnsCfsLibrary, setIsTbGrouping } = markupTableDataSlice.actions;
  
  export default markupTableDataSlice;